import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ActivityType = "doorKnock" | "handout" | "conversation" | "poster";

export interface ActivityDraft {
    id: string;
    type: ActivityType;
    payload: Record<string, unknown>;
    createdAt: string;
}

interface ActivityState {
    activeTab: ActivityType;
    drafts: ActivityDraft[];
    setActiveTab: (tab: ActivityType) => void;
    saveDraft: (draft: Omit<ActivityDraft, "createdAt">) => void;
    removeDraft: (id: string) => void;
}

export const useActivityStore = create<ActivityState>()(
    persist(
        (set) => ({
            activeTab: "doorKnock",
            drafts: [],
            setActiveTab: (tab) => set({ activeTab: tab }),
            saveDraft: (draft) =>
                set((state) => ({
                    drafts: [
                        ...state.drafts.filter((existing) => existing.id !== draft.id),
                        {
                            ...draft,
                            createdAt: new Date().toISOString()
                        }
                    ]
                })),
            removeDraft: (id) =>
                set((state) => ({
                    drafts: state.drafts.filter((draft) => draft.id !== id)
                }))
        }),
        {
            name: "centerreach-activity-drafts"
        }
    )
);